export const logPageTableContainerSx = {
  width: '100%',
  maxWidth: '100%',
  margin: '0 auto',
  boxSizing: 'border-box',
  paddingLeft: 'clamp(16px, 2.6vw, 34px)',
  paddingRight: 'clamp(16px, 2.6vw, 34px)',
  paddingTop: 'clamp(10px, 1.6vw, 18px)',
  paddingBottom: 'clamp(10px, 1.4vw, 14px)',
  height: '100%',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

export const logPageFilterContainerSx = {
  display: 'flex',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: '1rem',
  rowGap: '0.75rem',
  marginTop: '1rem',
  marginBottom: '1rem',
  minHeight: '32px',
};

export const logPageFilterWrapperSx = {
  display: 'flex',
  flexWrap: 'nowrap',
  gap: '1rem',
  rowGap: '0.75rem',
  alignItems: 'center',
};

export const logPageActionButtonsWrapperSx = {
  display: 'flex',
  flexWrap: 'wrap',
  flexShrink: 0,
  justifyContent: 'flex-end',
  alignItems: 'flex-end',
  gap: '1rem',
  rowGap: '0.75rem',
};

export const logPageTableRegionSx = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};
